// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file core/v1/user_events.proto (package core.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { User } from "./user_pb.js";
import { file_core_v1_user } from "./user_pb.js";
import type { ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file core/v1/user_events.proto.
 */
export const file_core_v1_user_events: GenFile = /*@__PURE__*/
  fileDesc("Chljb3JlL3YxL3VzZXJfZXZlbnRzLnByb3RvEgdjb3JlLnYxIqgDCglVc2VyRXZlbnQSLAoHY3JlYXRlZBgBIAEoCzIZLmNvcmUudjEuVXNlckNyZWF0ZWRFdmVudEgAEiwKB3VwZGF0ZWQYAiABKAsyGS5jb3JlLnYxLlVzZXJVcGRhdGVkRXZlbnRIABJGChVhZGRlZF90b19vcmdhbml6YXRpb24YAyABKAsyJS5jb3JlLnYxLlVzZXJBZGRlZFRvT3JnYW5pemF0aW9uRXZlbnRIABJOChlyZW1vdmVkX2Zyb21fb3JnYW5pemF0aW9uGAQgASgLMikuY29yZS52MS5Vc2VyUmVtb3ZlZEZyb21Pcmdhbml6YXRpb25FdmVudEgAEiwKB2ludml0ZWQYBSABKAsyGS5jb3JlLnYxLlVzZXJJbnZpdGVkRXZlbnRIABI3Cg1hZG1pbl9ncmFudGVkGAYgASgLMh4uY29yZS52MS5Vc2VyQWRtaW5HcmFudGVkRXZlbnRIABI3Cg1hZG1pbl9yZXZva2VkGAcgASgLMh4uY29yZS52MS5Vc2VyQWRtaW5SZXZva2VkRXZlbnRIAEIHCgVldmVudCIvChBVc2VyQ3JlYXRlZEV2ZW50EhsKBHVzZXIYASABKAsyDS5jb3JlLnYxLlVzZXIiXQoQVXNlclVwZGF0ZWRFdmVudBIkCg1wcmV2aW91c191c2VyGAEgASgLMg0uY29yZS52MS5Vc2VyEiMKDHVwZGF0ZWRfdXNlchgCIAEoCzINLmNvcmUudjEuVXNlciJfChxVc2VyQWRkZWRUb09yZ2FuaXphdGlvbkV2ZW50EhsKBHVzZXIYASABKAsyDS5jb3JlLnYxLlVzZXISIgoPb3JnYW5pemF0aW9uX2lkGAIgASgLMgkudHlwZXMuSUQiYwogVXNlclJlbW92ZWRGcm9tT3JnYW5pemF0aW9uRXZlbnQSGwoEdXNlchgBIAEoCzINLmNvcmUudjEuVXNlchIiCg9vcmdhbml6YXRpb25faWQYAiABKAsyCS50eXBlcy5JRCJiChBVc2VySW52aXRlZEV2ZW50EhsKBHVzZXIYASABKAsyDS5jb3JlLnYxLlVzZXISIgoPb3JnYW5pemF0aW9uX2lkGAIgASgLMgkudHlwZXMuSUQSDQoFZW1haWwYAyABKAkiWAoVVXNlckFkbWluR3JhbnRlZEV2ZW50EhsKBHVzZXIYASABKAsyDS5jb3JlLnYxLlVzZXISIgoPb3JnYW5pemF0aW9uX2lkGAIgASgLMgkudHlwZXMuSUQiWAoVVXNlckFkbWluUmV2b2tlZEV2ZW50EhsKBHVzZXIYASABKAsyDS5jb3JlLnYxLlVzZXISIgoPb3JnYW5pemF0aW9uX2lkGAIgASgLMgkudHlwZXMuSURCLVorcGFja2FnZXMvYmFja2VuZC1tb2R1bGUtY29yZS9hcGkvdjE7Y29yZV92MWIIZWRpdGlvbnNw6Ac", [file_core_v1_user, file_types]);

/**
 * @generated from message core.v1.UserEvent
 */
export type UserEvent = Message<"core.v1.UserEvent"> & {
  /**
   * @generated from oneof core.v1.UserEvent.event
   */
  event: {
    /**
     * @generated from field: core.v1.UserCreatedEvent created = 1;
     */
    value: UserCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: core.v1.UserUpdatedEvent updated = 2;
     */
    value: UserUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: core.v1.UserAddedToOrganizationEvent added_to_organization = 3;
     */
    value: UserAddedToOrganizationEvent;
    case: "addedToOrganization";
  } | {
    /**
     * @generated from field: core.v1.UserRemovedFromOrganizationEvent removed_from_organization = 4;
     */
    value: UserRemovedFromOrganizationEvent;
    case: "removedFromOrganization";
  } | {
    /**
     * @generated from field: core.v1.UserInvitedEvent invited = 5;
     */
    value: UserInvitedEvent;
    case: "invited";
  } | {
    /**
     * @generated from field: core.v1.UserAdminGrantedEvent admin_granted = 6;
     */
    value: UserAdminGrantedEvent;
    case: "adminGranted";
  } | {
    /**
     * @generated from field: core.v1.UserAdminRevokedEvent admin_revoked = 7;
     */
    value: UserAdminRevokedEvent;
    case: "adminRevoked";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message core.v1.UserEvent.
 * Use `create(UserEventSchema)` to create a new message.
 */
export const UserEventSchema: GenMessage<UserEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_user_events, 0);

/**
 * @generated from message core.v1.UserCreatedEvent
 */
export type UserCreatedEvent = Message<"core.v1.UserCreatedEvent"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message core.v1.UserCreatedEvent.
 * Use `create(UserCreatedEventSchema)` to create a new message.
 */
export const UserCreatedEventSchema: GenMessage<UserCreatedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_user_events, 1);

/**
 * @generated from message core.v1.UserUpdatedEvent
 */
export type UserUpdatedEvent = Message<"core.v1.UserUpdatedEvent"> & {
  /**
   * @generated from field: core.v1.User previous_user = 1;
   */
  previousUser?: User;

  /**
   * @generated from field: core.v1.User updated_user = 2;
   */
  updatedUser?: User;
};

/**
 * Describes the message core.v1.UserUpdatedEvent.
 * Use `create(UserUpdatedEventSchema)` to create a new message.
 */
export const UserUpdatedEventSchema: GenMessage<UserUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_user_events, 2);

/**
 * @generated from message core.v1.UserAddedToOrganizationEvent
 */
export type UserAddedToOrganizationEvent = Message<"core.v1.UserAddedToOrganizationEvent"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message core.v1.UserAddedToOrganizationEvent.
 * Use `create(UserAddedToOrganizationEventSchema)` to create a new message.
 */
export const UserAddedToOrganizationEventSchema: GenMessage<UserAddedToOrganizationEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_user_events, 3);

/**
 * @generated from message core.v1.UserRemovedFromOrganizationEvent
 */
export type UserRemovedFromOrganizationEvent = Message<"core.v1.UserRemovedFromOrganizationEvent"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message core.v1.UserRemovedFromOrganizationEvent.
 * Use `create(UserRemovedFromOrganizationEventSchema)` to create a new message.
 */
export const UserRemovedFromOrganizationEventSchema: GenMessage<UserRemovedFromOrganizationEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_user_events, 4);

/**
 * @generated from message core.v1.UserInvitedEvent
 */
export type UserInvitedEvent = Message<"core.v1.UserInvitedEvent"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;

  /**
   * @generated from field: string email = 3;
   */
  email: string;
};

/**
 * Describes the message core.v1.UserInvitedEvent.
 * Use `create(UserInvitedEventSchema)` to create a new message.
 */
export const UserInvitedEventSchema: GenMessage<UserInvitedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_user_events, 5);

/**
 * @generated from message core.v1.UserAdminGrantedEvent
 */
export type UserAdminGrantedEvent = Message<"core.v1.UserAdminGrantedEvent"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message core.v1.UserAdminGrantedEvent.
 * Use `create(UserAdminGrantedEventSchema)` to create a new message.
 */
export const UserAdminGrantedEventSchema: GenMessage<UserAdminGrantedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_user_events, 6);

/**
 * @generated from message core.v1.UserAdminRevokedEvent
 */
export type UserAdminRevokedEvent = Message<"core.v1.UserAdminRevokedEvent"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message core.v1.UserAdminRevokedEvent.
 * Use `create(UserAdminRevokedEventSchema)` to create a new message.
 */
export const UserAdminRevokedEventSchema: GenMessage<UserAdminRevokedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_user_events, 7);

